fx.ns("filters", class SortPhotosAdded extends fx.Filter {

    /**
     * Sort picture but date there were added. direction parameter allows to sort from the newest to the oldest, and the opposite.
     * @param {String} direction : "ASC" / "DESC"
     */
	constructor(direction, labels)
	{
		super();	

        this._sortDirection = direction;
        this._showLabels = labels;

        this._sortHandler = this.sort.bind(this);
        this._filterHandler = this._filterPhotos.bind(this);

		this.label = fx.text("Ordre d'ajout");
	}

	get photosused()
	{
		return this._photosused;
	}

	set photosused(val)
	{
		this._photosused = val;

		this.refresh();
		this.trigger("updated");
	}

    // sort direction : ASC / DESC
    newerToOlder()
    {
        this._sortDirection = "ASC";
        this.refresh();
		this.trigger("updated");
    }

    olderToNewer()
    {
        this._sortDirection = "DESC";
        this.refresh();
		this.trigger("updated");
    }

	exec()
	{
		if (!this.rawData) return;
		
		let photos = this.rawData;
		
		// sort pictures chronologically
		photos = photos.sort( this._sortHandler );
		photos = photos.filter(this._filterHandler );
		
		// calculate average
		let ret = [], date1, date2, sameDay = false;
		for(let i = 0; i < photos.length; i++)
		{
			if (photos[i].deleted)
				continue;

			// skip shared photos which have not been validated
			if (photos[i].labels == "share-uploader" && photos[i].validated == 0)
				continue;

			if (!this.photosused && photos[i].number > 0)
				continue;

			if (i == 0)
				sameDay = false;
			else
			{
				date1 = parseInt(photos[i-1].date_unix, 10);
				date2 = parseInt(photos[i].date_unix, 10);
				
				sameDay = !Date.notSameDay(date1, date2 );
			}
			
			if (!sameDay && this._showLabels)
				ret.push( {type : "label", text : this._getDate(photos[0].date, true) /*Date.unixTimeToDate( parseInt(photos[i].date_unix, 10),  true, true, true)*/ } );	
				
			ret.push(photos[i]);

		}
		return ret;
	}

	sort(item1, item2)
	{
        let date1 = typeof item1.date == "string" ? Date.fromSQL(item1.date) : item1.date;//parseInt(item1.date_unix, 10);
		let date2 = typeof item1.date == "string" ? Date.fromSQL(item2.date) : item2.date;//parseInt(item2.date_unix, 10);

		if (date1 > date2)
			return this._sortDirection == "ASC" ? -1 : 1;
		if (date1 < date2)
			return this._sortDirection == "ASC" ? 1 : -1;
		else
			return 0
	}

	_filterPhotos(photo)
	{
		if ( !this.photosused && photo.number > 0)
			return false;

		return !photo.deleted;
	}

	_getDate(date, pretty)
	{
		let d;
		if (date == "0000-00-00 00:00:00")
			d = new Date();
		else
			d = ( typeof date == "string" ? new Date(date.replace(/-/g, "/")) : date);

		return pretty ? d.pretty( fx.currentLocale() ) : d;
	}
	
});
